import { request } from './http.js'

export async function fetchUsers() {
  const data = await request('/api/users')
  return data.users || []
}

export async function createUser(username, password) {
  const data = await request('/api/users', {
    method: 'POST',
    body: JSON.stringify({ username, password }),
  })
  return data.users || []
}

export async function changeUserPassword(username, password) {
  const data = await request(`/api/users/${encodeURIComponent(username)}/password`, {
    method: 'PUT',
    body: JSON.stringify({ password }),
  })
  return data.users || []
}

export async function removeUser(username) {
  const data = await request(`/api/users/${encodeURIComponent(username)}`, {
    method: 'DELETE',
  })
  return data.users || []
}
